import React from 'react';
import { Link } from 'react-router-dom';

const typeColors = {
  normal: 'bg-gray-400',
  fire: 'bg-red-500',
  water: 'bg-blue-500',
  electric: 'bg-yellow-400',
  grass: 'bg-green-500',
  ice: 'bg-blue-300',
  fighting: 'bg-red-700',
  poison: 'bg-purple-500',
  ground: 'bg-yellow-600',
  flying: 'bg-indigo-400',
  psychic: 'bg-pink-500',
  bug: 'bg-green-400',
  rock: 'bg-yellow-800',
  ghost: 'bg-purple-700',
  dragon: 'bg-indigo-700',
  dark: 'bg-gray-800',
  steel: 'bg-gray-500',
  fairy: 'bg-pink-300'
};

function TypeBadge({ type, size = 'md', clickable = true }) {
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  const baseClasses = `inline-flex items-center font-medium text-white rounded-full capitalize transition-transform ${sizeClasses[size]} ${typeColors[type] || 'bg-gray-400'}`;

  if (!clickable) {
    return (
      <span className={baseClasses}>
        {type}
      </span>
    );
  }

  return (
    <Link 
      to={`/type/${type}`}
      className={`${baseClasses} hover:scale-105 focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`}
      aria-label={`View all ${type} type Pokemon`}
    >
      {type}
    </Link>
  );
}

export default TypeBadge;